import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import React, { useContext } from "react";
import SeatsContext from "../store/seats/seats-context";
// import { format } from 'date-fns';
import AuthContext from "../store/auth/auth-context";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { LoadingButton } from "@mui/lab";
import useHttp from "../hooks/use-http";
import date from "date-and-time";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Plan = () => {
  const seatsCxt = useContext(SeatsContext);
  const authCxt = useContext(AuthContext);

  const billingDate = new Date(seatsCxt.lastRenewal);
  const nextBillingDate = new Date(billingDate.setFullYear(billingDate.getFullYear() + 1))
  //  console.log()

  const [openState, setOpenState] = React.useState(false);
  const [isSubscriptionCancelled, setIsSubscriptionCancelled] =
    React.useState(false);

  const {
    isLoading,
    isError,
    message,
    sendRequest: cancelSubscription,
  } = useHttp();

  //     const aYearFromNow = new Date();
  // aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);

  // const billingDate = new Date(seatsCxt.billingDate)
  // const billingDate_oneAdded= billingDate.setFullYear(billingDate.getFullYear() + 1)

  // console.log(format(billingDate_oneAdded, 'yyyy/MM/dd'))
  const cancelSubscriptionHandler = (data: any) => {
    setOpenState(true);
  };

  const handleClose = () => {
    setOpenState(false);
  };

  const cancelSubscriptionResponse = (res: any) => {
    // console.log(res);
    if (res.error === false) {
      setIsSubscriptionCancelled(true);
      setTimeout(() => {
        setOpenState(false);
        setIsSubscriptionCancelled(false);
        window.location.reload();
      }, 4000);
    }
  };

  const handleCancelSubscription = (data: any) => {
    cancelSubscription(
      {
        URL: "/api/stripe-payment/cancel-subscription",
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: {
          // subscriptionID: "sub_1NuiaYSAbyotjTgQUZ00Tlkb",
          account_email: authCxt.userInfo?.email,
          account_ID: authCxt.userInfo?.accountID,
        },
      },
      cancelSubscriptionResponse
    );

    // setOpenState(false);
  };

  return (
    <>
      <Dialog open={openState} onClose={handleClose}>
        <DialogTitle sx={{ textAlign: "center" }}>
        {isSubscriptionCancelled == false ? "Cancel subscription" : ""}
        </DialogTitle>
        <DialogContent>
          {isSubscriptionCancelled == false ? (
            <>
              <DialogContentText>
                Reach out to us with a message and we'll respond to you at the
                earliest
              </DialogContentText>
              <Box mt={3}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isLoading}
                    onClick={handleCancelSubscription}
                    sx={{
                      mt: 3,
                      mb: 2,
                      width: "250px",
                      bgcolor: "#F47907",
                      fontSize: "11px",
                      "&.Mui-disabled": {
                        background: "#f6d9b9",
                      },
                      "&:hover": {
                        bgcolor: "#FF8D24",
                      },
                    }}
                  >
                    Confirm
                  </LoadingButton>
                </Box>
              </Box>
            </>
          ) : (
            <Grid sx={{ width: "100%", textAlign: "center" }}>
              <Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <LoadingButton
                    variant="text"
                    sx={{
                      mt: 3,
                      mb: 2,
                      width: "100px",

                      height: "100px",
                    }}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ color: "#5ACE65", fontSize: "60px" }}
                    />
                  </LoadingButton>
                </Box>

                <Typography
                  component="h5"
                  variant="h5"
                  sx={{ fontSize: "30px" }}
                >
                  {"Subscription cancelled Successfully"}
                </Typography>
                {/* <Typography
                  variant="body2"
                  mb={2}
                  mt={1}
                  sx={{ color: "gray", fontSize: "16px" }}
                >
                  {"We'll get back to you shortly."}
                </Typography> */}
              </Box>
            </Grid>
          )}
        </DialogContent>
      </Dialog>

      <Grid display={"flex"} container>
        <Grid item xs={6}>
          <Grid display={"flex"} container>
            <Grid item xs={6} p={1}>
              Plan
            </Grid>
            <Grid item xs={6} p={1}>
              <Typography variant="body1">
                {seatsCxt.plan}{" "}
                {/* <Button
                  disabled
                  aria-label="Download Extension"
                  variant="outlined"
                  sx={{
                    height: "25px",
                    marginLeft: "10px",
                    borderRadius: "5px",
                    color: "#F47907",
                  }}
                >
                  Edit
                </Button> */}
              </Typography>
            </Grid>
          </Grid>
          <Grid display={"flex"} container>
            <Grid item xs={6} p={1}>
              Total Users
            </Grid>
            <Grid item xs={6} p={1}>
              <Typography variant="body1">{seatsCxt.availableSeats}</Typography>
            </Grid>
          </Grid>
          <Grid display={"flex"} container>
            <Grid item xs={6} p={1}>
              Allocated Users
            </Grid>
            <Grid item xs={6} p={1}>
              <Typography variant="body1">{seatsCxt.consumedSeats}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid display={"flex"} container>
            <Grid item xs={6} p={1}>
              Billing Cycle
            </Grid>
            <Grid item xs={6} p={1}>
              <Typography variant="body1">
                {seatsCxt.plan === "Basic" ? "-" : "Annual"}{" "}
              </Typography>
            </Grid>
          </Grid>
          <Grid display={"flex"} container>
            <Grid item xs={6} p={1}>
              Next Billing
            </Grid>
            <Grid item xs={6} p={1}>
              <Typography variant="body1">
                {seatsCxt.plan === "Basic"
                  ? "-"
                  : date.format(nextBillingDate,'DD-MMM-YY hh:mm A')}
              </Typography>
            </Grid>
          </Grid>
          <Grid display={"flex"} container>
            <Grid item xs={6} p={1}>
              Subscription Status
            </Grid>
            <Grid display={"flex"} item xs={6} p={1}>
              <Grid>
                <Typography variant="body1" sx={{color:seatsCxt.subscriptionStatus===false? "red": "", fontWeight:"bold"}}>
                  {seatsCxt.availableSeats>10 && seatsCxt.subscriptionStatus===true
                    ? "Active"
                    : seatsCxt.availableSeats>10 && seatsCxt.subscriptionStatus===false ? "Cancelled" : "-"}
                </Typography>
              </Grid>
              <Grid>
              {seatsCxt.availableSeats>10 && seatsCxt.subscriptionStatus===true ? (
                  
                  <Button
                    onClick={() =>
                      cancelSubscriptionHandler({ cancel: "Upgrade support" })
                    }
                    variant="contained"
                    sx={{
                      ml: 2,
                      width: "90px",
                      height: "20px",
                      bgcolor: "#3A3A3A",
                      fontSize: "11px",
                      "&:hover": {
                        bgcolor: "#3a3a3ae3",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Plan;
